var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleCircleMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_01",
    transform: "translate(-120.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(120.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E5DDFF",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#8662FF",
    cx: 30,
    cy: 30,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#E5DDFF",
    strokeWidth: 3,
    fill: "#E5DDFF",
    cx: 30,
    cy: 30,
    r: 9.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCircleMarker);
export default __webpack_public_path__ + "static/media/purple-circle-marker.4e96a0a3c6f83f88a105118b60e4d207.svg";
export { ForwardRef as ReactComponent };